/** For given dd/mm/yyyy date string, return a yyyy-mm-dd string. */
export function ukToIsoDate(uk_date: string) {
  if (uk_date.match(/^[0-9]{2}\/[0-9]{2}\/[0-9]{4}$/)) {
    return uk_date.split('/').reverse().join('-')
  }
  return uk_date
}
